import React, { useState } from 'react';
import '../App.css'; // Add your styling if needed
import { createGlobalStyle } from 'styled-components';

// Global styles for paragraphs
const GlobalStyle = createGlobalStyle`
  p {
    font-size: 16px;
    text-align: left;
    margin-left: 10px;
  }
`;

// BleWifiPage Component (unchanged)
function BleWifiPage({ onClose }) {
    const [ssid, setSsid] = useState('Boteyes');
    const [password, setPassword] = useState('b0teyest@b');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [website, setWebsite] = useState('195.161.114.31'); // Initial value for the website field
    const [isWebsiteEditable, setIsWebsiteEditable] = useState(false);

    const handleSsidChange = (e) => setSsid(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);
    const handleWebsiteChange = (e) => setWebsite(e.target.value);
    const toggleWebsiteEditability = () => setIsWebsiteEditable(!isWebsiteEditable); // Toggle the editable state
    const togglePasswordVisibility = () => setIsPasswordVisible(!isPasswordVisible);

    const log = (...args) => {
        const line = args.map((arg) => (typeof arg === 'string' ? arg : JSON.stringify(arg))).join(' ');
        document.querySelector('#log').textContent += line + '\n';
    };

    const sendData = () => {
        try {
            let ssidValue = "";
            let ssidInput = document.getElementById("ssid").value;
            if (ssidInput == "") {
                log(`Введите имя точки доступа WiFi`);
                return;
            } else {
                ssidValue = ssidInput + "\r";
            }

            let passwValue = "";
            let passwInput = document.getElementById("passw").value;
            if (passwInput == "") {
                log(`Введите пароль WiFi`);
                return;
            } else {
                passwValue = passwInput + "\r";
            }

            let websiteValue = "";
            let websiteInput = document.getElementById("website").value;
            if (websiteInput == "") {
                log(`Введите адрес вебсайта`);
                return;
            } else {
                websiteValue = "mqtt://" + websiteInput + "\r";
            }

            let concatenatedString = "1," + ssidValue + "," + passwValue + "," + websiteValue;
            log(`Отправленные данные: ${concatenatedString}`);
            onClose(); // Close the modal after sending data
        } catch (error) {
            log(error.message);
        }
    };

    return (
        <div>
            <GlobalStyle />
            <h2>Подключение IoT устройства к сети WiFi</h2>
            <p>
                Для подключения IoT устройства к WiFi надо подключиться к нему через Bluetooth Low Energy (BLE).
            </p>
            {/* Rest of the BleWifiPage content */}
            <input type="text" id="ssid" name="inputField1" value={ssid} onChange={handleSsidChange} />
            <input type={isPasswordVisible ? 'text' : 'password'} id="passw" name="inputField2" value={password} onChange={handlePasswordChange} />
            <label>
                <input type="checkbox" checked={isPasswordVisible} onChange={togglePasswordVisibility} />
                Показать пароль
            </label>
            <input type="text" id="website" name="inputField3" value={website} onChange={handleWebsiteChange} readOnly={!isWebsiteEditable} />
            <button onClick={toggleWebsiteEditability}>
                {isWebsiteEditable ? 'Отключить редактирование' : 'Разрешить редактирование адреса вебсайта'}
            </button>
            <button onClick={sendData}>Отправить</button>
            <h3>Ответ устройства:</h3>
            <pre id="log"></pre>
        </div>
    );
}

// Parent Component with Popup
function App() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const openPopup = () => setIsPopupOpen(true);
    const closeWiFiPopup = () => setIsPopupOpen(false);

    const connectToWiFi = (selectedIcon) => {
        console.log('Selected Icon:', selectedIcon);
        openPopup(); // Open the popup when this function is called
    };

    return (
        <div>
            <button onClick={() => connectToWiFi('IoT-Device')}>Подключить к WiFi</button>

            {/* Popup Implementation */}
            {isPopupOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                    onClick={closeWiFiPopup} // Close popup when clicking outside
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            padding: '20px',
                            borderRadius: '8px',
                            maxWidth: '600px',
                            width: '90%',
                            position: 'relative', // For close button positioning
                        }}
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                    >
                        <button
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '20px',
                            }}
                            onClick={closeWiFiPopup}
                        >
                            &times;
                        </button>
                        <BleWifiPage onClose={closeWiFiPopup} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default App;